import React, { Component } from 'react'
import { connect } from 'react-redux'
import actions from '../actions/index'
import Skeleton from 'react-loading-skeleton'
import { confirmAlert } from 'react-confirm-alert'
import {  CUSTOMERSERVICESACCESS } from '../utils/constants'

var qs = require('qs')
export class Impersonate extends Component {

  componentDidMount() {
    if (this.props.user && this.props.match.params.id) {

      if (this.props.impersonateData && this.props.impersonateData.user.userId != undefined && sessionStorage.getItem("userData") != null) {       
        window.location.assign('/#/personalize')
      } else {
        this.props.callImpersonateUser(this.props.match.params.id).then(() => {
          const adminToolUrl = `${process.env.ADMIN_TOOL_USER_URL}`

          if (this.props.impersonateData.error != '') {
            var statusCode = this.props.impersonateData.error.includes('status code 404') ? 404 :
              this.props.impersonateData.error.includes('status code 403') ? 403 : 500;

            this.props.impersonateData.error = ''

            // call error modal
            this.showErrorModal(statusCode, adminToolUrl)

          } else {
            var userData = {
              id: this.props.impersonateData.user.userId,
              name: this.props.impersonateData.user.name,              
              companyId: this.props.impersonateData.user.companyId,
              companyName: this.props.impersonateData.user.companyName,
              adminId: this.props.user.profile.UserID
            }

            if(this.props.user.profile.Role == CUSTOMERSERVICESACCESS) {
              if(this.props.impersonateData.user.noLongerWithCompany === true || this.props.impersonateData.user.active === false){
                confirmAlert({
                  customUI: ({ onClose }) => {
                    return this.checkImpersonatedUserStatus(adminToolUrl)
                  },
                  closeOnEscape: false,
                  closeOnClickOutside: false
                });
              } else {
                sessionStorage.setItem("userData", JSON.stringify(userData))                
                window.location.assign('/#/personalize')
              }            
            } else {
              confirmAlert({
                customUI: ({ onClose }) => {
                  if(this.props.impersonateData.user.noLongerWithCompany === true || this.props.impersonateData.user.active === false){
                    return this.checkImpersonatedUserStatus(adminToolUrl)
                  } else {
                    return (
                      <div className='custom-ui'>
                        <h1>You are about to manage the alert settings for the MLex user: {this.props.impersonateData.user.name}</h1>
                        <p>By continuing, you confirm you are an authorized MLex Admin User at your organization and you are responsible for changes to this user’s alert settings whilst accessing their account.</p>
                        <p>{this.props.impersonateData.user.name} will be notified, via email, that you have accessed their account to manage it.</p>              
                        <div className='react-confirm-alert-button-group'>
                          <button onClick={() => {
                             window.open("", '_self').window.close()
                          }}>Cancel</button>
                          <button
                            onClick={() => {
                              this.sendConfirmationEmailApi(userData, adminToolUrl)
                              onClose()
                            }}
                          >
                            Proceed
                          </button>
                        </div>
                      </div>
                    );
                  }
                },
                closeOnEscape: false,
                closeOnClickOutside: false
              });
            }
          }
        })
      }
    }
  }

  showErrorModal(statusCode, adminToolUrl){
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui-error'>
            {
              statusCode == 403 ? 
                <><h1>Sorry, you are not authorized to manage this user</h1>
                <p>This user’s subscription is not connected to your organization.</p></>
              : statusCode == 404 ? 
                <><h1>Sorry, you are not able to manage this user</h1>
                {
                  this.props.user.profile.Role == CUSTOMERSERVICESACCESS ? 
                  <p>Please go back to the contact record in Salesforce and check this user has a valid subscription.<br/>You can now close this window.</p>
                  : <p>Please contact Customer Services for assistance with this user's subscription.</p>
                }
                </>
                : 
                <><h1>Sorry, an error has occurred</h1>
                 {
                  this.props.user.profile.Role == CUSTOMERSERVICESACCESS ? 
                  <p>Please try again to manage this user from the contact record in Salesforce. If the error persists, please contact Tech Support for assistance.<br/>You can now close this window.</p>
                  : <p>Please try again to manage this user from the Admin Tool. If the error persists, please contact Customer Services for assistance.</p>
                }
                </>
            }
            
            { this.showBackButtonBasedOnUserStatus(adminToolUrl) }
          </div>
        );                 
      },
      closeOnEscape: false,
      closeOnClickOutside: false
    });
  }

  checkImpersonatedUserStatus(adminToolUrl) {
    if(this.props.impersonateData.user.noLongerWithCompany === true){
      return (
        <div className='custom-ui-error'>
          <h1>No Longer with the Company</h1>
          {
            this.props.user.profile.Role == CUSTOMERSERVICESACCESS ?
              <p>This user is currently marked as ‘no longer with the company’.  Please reinstate this user.  Once that is done you will be able to manage this user.<br/>You can now close this window.</p>
              : <p>This user is currently marked as ‘no longer with the company’. Please contact Customer Services to request that this user is reinstated. Once that is done you will be able to login to the User Admin Tool to re-enable their account and then manage this user.</p>
          }          
          { this.showBackButtonBasedOnUserStatus(adminToolUrl) }
        </div>
      );
    } else if (this.props.impersonateData.user.active === false){
      return (
        <div className='custom-ui-error'>
          <h1>No Active Subscription</h1>
          {
            this.props.user.profile.Role == CUSTOMERSERVICESACCESS ?
              <p>This user does not have an active MLex subscription.  Please add them as a new user or re-enable their account. Once that is completed you will be able to manage this user.<br/>You can now close this window.</p>
              : <p>This user does not have an active MLex subscription. Please login to the User Admin Tool to add them as a new user or re-enable their account. Once that is completed you will be able to manage this user.</p>
          }            
          { this.showBackButtonBasedOnUserStatus(adminToolUrl) }
        </div>
      );
    }
  }

  showBackButtonBasedOnUserStatus(adminToolUrl){
   if(this.props.user.profile.Role != CUSTOMERSERVICESACCESS){
     return (
      <div className='react-confirm-alert-button-group'>
      <button onClick={() => {  window.open("", '_self').window.close() }}>Cancel</button>
    </div>
     )
   } 

   return <></>
  }

  sendConfirmationEmailApi(userData, adminToolUrl){
    this.props.sendConfirmationEmail(this.props.match.params.id).then(() => {

      if (this.props.confirmationEmailResponse.error != '') {
        this.showErrorModal(500, adminToolUrl)
      } else {
        sessionStorage.setItem("userData", JSON.stringify(userData))

        window.location.assign('/#/personalize')
      }
    })
  }

  checkBoxChecked() {
    return true
  }

  render() {
    if (this.props.user && this.props.impersonateData.fetching == false && this.props.confirmationEmailResponse.fetching == false) {
      return (
        <div></div>
      )
    } else {
      return (
        <div className='grid-content-full skeleton'>
          <div className=''>
            <Skeleton height={10} count={15} />
          </div>
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    user: state.oidc.user,
    impersonateData: state.impersonate,
    confirmationEmailResponse: state.sendConfirmationEmail
  }
}

const mapDispatchToProps = (dispatch) => ({
  callImpersonateUser: (impersonateUserId) => new Promise((resolve, reject) => {
    dispatch(actions.impersonateUser(impersonateUserId)).then(() => {
      resolve();
    })
  }),
  sendConfirmationEmail: (impersonateUserId) => new Promise((resolve, reject) => {
    dispatch(actions.sendConfirmationEmail(impersonateUserId)).then(() => {
      resolve();
    })
  })
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Impersonate)
